<div class="relative">
    <div class="filters flex align-items-center mb-4">
        <span>filtros:</span>
        <ng-container *ngFor="let filter of filters">
            <ng-container  [ngSwitch]="filter.type">
            <ng-container *ngSwitchCase="'DROPDOWN'">
                <ng-container *ngFor="let data of filter.data; let position = index">
                <p-chip *ngIf="data.checklist"  class="ml-2"  [label]="data.value" [removable]="true" (onRemove)="remove(filter, position)"></p-chip>
                </ng-container>
            
            </ng-container>
                
            <ng-container *ngSwitchCase="'DATE'">
                <p-chip *ngIf="filter.data.length > 0"  class="ml-2"  label="{{filter.data[0] | date:'dd/MM/yyyy'}} - {{filter.data[1] | date:'dd/MM/yyyy'}}" [removable]="true" (onRemove)="remove(filter)"></p-chip>
            </ng-container>
            </ng-container>
        </ng-container>
        
        <p-button class="ml-2" (click)="clearFilter()" size="small" label="limpar filtros" [link]="true" [text]="true"></p-button>
    </div>
    <!--<div class="flex">
        <table class="w-full" [ngClass]="theme">
            <thead>
                <tr class="header">
                    <th class="teste">

                    </th>
                    <th *ngFor="let header of headers; let i = index">
                    <div [ngClass]="{'flex gap-2 align-items-center': i == 0}">
                        <p-checkbox *ngIf="checklist && i == 0" [ngModel]="isAllChecked()" (onChange)="checkAll($event)" [binary]="true" inputId="binary"></p-checkbox>
                        <ng-container
                        *ngTemplateOutlet="header">
                        </ng-container>
                    </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="pl-1" *ngFor="let dadosLinha of dados; let position = index">
                    <td class="teste">

                    </td>
                    <td *ngFor="let coluna of colunas; let i = index" [style.width.%]="this.widthColumns[i]">
                    <div [ngClass]="{'flex gap-2 align-items-center': i == 0}">
                        <p-checkbox [(ngModel)]="dadosLinha.checklist" *ngIf="checklist && i == 0" [binary]="true" inputId="binary"></p-checkbox>
                        <ng-container
                            *ngTemplateOutlet="coluna; context: { dadosLinha, position }">
                        </ng-container>
                    </div>
                    </td>
                </tr>
                <tr *ngFor="let linha of linhas" >
                <ng-container
                        *ngTemplateOutlet="linha; context: { dados }">
                    </ng-container>
                </tr>
            </tbody>
        </table>
    </div>-->

    <div class="table-timeline">
        <div class="header">
            <div class="grid m-0">
                <div class="col p-1" *ngFor="let header of headers; let i = index">
                    <ng-container
                    *ngTemplateOutlet="header">
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="body">
                <div class="conference-center-line"></div>
                <div class="flex mt-3 card-conatiner" *ngFor="let dadosLinha of dados; let position = index">
                    <div class="timeline">
                        <div *ngIf="position == 0 || dados[position - 1]?.date != dadosLinha.date">
                            {{dadosLinha.date | date:'dd/MM'}}
                        </div>
                    </div>
                    <div class="timeline-card w-full">
                        <div class="grid m-0">
                            <div class="col p-1" *ngFor="let coluna of colunas; let i = index">
                                <div class="flex align-items-center justify-content-center h-full">
                                    <ng-container
                                    *ngTemplateOutlet="coluna; context: { dadosLinha, position }">
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
    <div class="mt-2">
        <p-paginator *ngIf="paginator" (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"></p-paginator>
      </div>
    <div class="loading" *ngIf="loading">
        <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
</div>

  